import {API} from '../api'

const login = async (email, password) => {
  return API.post('/api/user/login' , {email, password})
}

const register = async (name, email, password, type) => {
  return API.post('/api/user/register' , {name, email, password, type})
}

const update = async (firstname, lastname, phonenumber, email) => {
  return API.post('/api/user/update' , {firstname, lastname, phonenumber,email})
}

const getAuthenticatedUser = async () => {
  return API.get('/api/user/')
}

const requestPassword = async (email) => {
  return API.post('/api/user/request' , {email})
}

const resetPassword = async (token, password) => {
  return API.post('/api/user/reset/'+token , {password})
}

const invite = async (email, type) => {
  return API.post('/api/user/newinvite', {email, type})
}

const inviteRegister = async (token, password, phone, firstname,lastname) => {
  return API.post('/api/user/invite', {token, password, phone, firstname,lastname})
}

const isAuth = () => {
  if(localStorage.token) return true;
  return false;
}

const isNotAuthGuard = async (to, from, next) => {
  if(!isAuth()) next();
  else next('/');
}

const isAuthGuard = async (to, from, next) => {
  if(isAuth()) next();
  else next('/join/login');
}

const logout = () =>{
  localStorage.removeItem('token');
}

export default {
  login,
  register,
  getAuthenticatedUser,
  isAuth,
  logout,
  isNotAuthGuard,
  isAuthGuard,
  update,
  requestPassword,
  resetPassword,
  invite,
  inviteRegister
};